export const platform = process.env.CORDOVA_PLATFORM || 'browser';
